// filo-takip/src/components/Navbar.js
import "./Navbar.css";
import React, { useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const Navbar = () => {
  const { user, role, userPermissions, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const normalizedRole = (role || "").toLocaleLowerCase("tr");
  const isCreator = normalizedRole === "oluşturucu";
  const perms = userPermissions?.filotakip || {};

  // Yetki tanımlamaları
  const canAracListesi   = isCreator || perms.takip    === true;
  const canPuantaj       = isCreator || perms.yonetici === true || perms.giris === true;
  const canBelgeYonetimi = isCreator || perms.yonetici === true;
  const canBelgeYukleme  = isCreator || perms.takip    === true || perms.giris === true;
  const canAdmin         = isCreator;

  // Hamburger dışına tıklayınca kapat
  React.useEffect(() => {
    const onDown = (e) => {
      if (e.target.closest(".hamburger")) return;
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/");
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" className="navbar-logo" alt="Logo" />
        <span className="navbar-title">Filo Takip</span>
      </div>

      {user && (
        <>
          <div className="hamburger" onClick={() => setMenuOpen(s => !s)}>
            <span></span><span></span><span></span>
          </div>

          <div className={`navbar-links ${menuOpen ? "show" : ""}`} ref={menuRef}>
            {canAracListesi && (
              <NavLink className="navbar-link" to="arac-listesi">Araç Listesi</NavLink>
            )}
            {canPuantaj && (
              <NavLink className="navbar-link" to="puantaj">Puantaj</NavLink>
            )}
            {canBelgeYukleme && (
              <NavLink className="navbar-link" to="belge-yukleme">Belge Yükleme</NavLink>
            )}
            {canBelgeYonetimi && (
              <NavLink className="navbar-link" to="belge-yonetimi">Belge Yönetimi</NavLink>
            )}
            {canAdmin && (
              <NavLink className="navbar-link" to="admin">Admin</NavLink>
            )}

            <NavLink className="navbar-link" to="/secilen-proje">Proje Seç</NavLink>
            <button className="logout-button" onClick={handleLogout}>Çıkış</button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
